import $ from "jquery";
import toastr from "toastr";
import Icon from "../../../public/cp/media/images/Logo.png";

// eslint-disable-next-line
export function onSignIn(response) {
  const responsePayload = parseJwt(response.credential);
  let timeout = 1000;
  let fetchUrl = "/api/auth/login";
  $.ajax({
    url: fetchUrl,
    type: "POST",
    data: {
      credential: response.credential,
    },
    success: function(result) {
      if (!result.success || !result.data) {
        toastr.info("Login failed", "Failed!");
        return;
      }
      const responseData = result.data;
      if (responseData.code !== 0) {
        toastr.info(responseData.message, "Failed!");
        return;
      }
      toastr.success(
        "Have Fun " + (result.data.user?.name || responsePayload.given_name || "there") + "!",
        "Welcome to Reno"
      );
      setTimeout(function() {
        window.location.replace(responseData.redirect);
      }, timeout);
    },
  });
}

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

// Development login functionality
document.addEventListener('DOMContentLoaded', function() {
  const devLoginBtn = document.getElementById('devLoginBtn');
  if (devLoginBtn) {
    devLoginBtn.addEventListener('click', function() {
      devLoginBtn.disabled = true;
      devLoginBtn.innerHTML = '🔄 Logging in...';

      fetch('/api/auth/dev-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data.success && data.data && data.data.code === 0) {
            toastr.success(
              "Welcome to Reno, " + data.data.user.name + "!",
              "Development Login Successful"
            );
            setTimeout(function() {
              window.location.replace(data.data.redirect);
            }, 1000);
          } else {
            const message = data.data?.message || data.message || 'Login failed';
            toastr.error(message, "Login Failed");
            devLoginBtn.disabled = false;
            devLoginBtn.innerHTML = '🚀 Dev Login (Test User)';
          }
        })
        .catch(error => {
          console.error('Dev login error:', error);
          toastr.error('Network error during login', 'Login Failed');
          devLoginBtn.disabled = false;
          devLoginBtn.innerHTML = '🚀 Dev Login (Test User)';
        });
    });
  }
});

window.onload = function() {
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.rel = "icon";
  link.href = Icon;
  document.getElementsByTagName("head")[0].appendChild(link);

  document.getElementById("logoFrontAndCenter").src = Icon;
};
